'use client';

import React from 'react';
import styles from './styles.module.scss';
import ActivityContainer from '@/components/ActivityContainer/ActivityContainer';
import LandingPage from '@/components/LandingPage/LandingPage';
import AsthmaCanadaLogo from '@/components/AsthmaCanadaLogo';
import UserActionToolBar from '@/components/UserActionToolbar';
import useScreenStore from '@/stores/screen';

export default function RootPage() {
  const { isExpanded } = useScreenStore();
  return (
    <div className={styles.container}>
      <AsthmaCanadaLogo />
      <div
        className={`${styles.containerWrapper} ${isExpanded ? 'is-expanded' : ''}`}
      >
        <UserActionToolBar />
        <ActivityContainer backgroundType="landing">
          <LandingPage />
        </ActivityContainer>
      </div>
    </div>
  );
}
